import { render } from "./App.vue?vue&type=template&id=2a898b96&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2a898b96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a898b96"

export default script